import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import Signup from './containers/signupContainer';
// import MultiProfiles from './containers/multiProfileContainer';
import Login from './containers/loginContainer';
import Reset from './containers/resetContainer';
import Logout from './containers/logoutContainer';
import history from './utils/history';
import cookieLib from './helpers/cookieLib';
import LandingPage from './containers/landingPageContainer';
import SnackBar from './containers/snackbarContainer';
import UserInfo from './containers/getUserInfo';
// import ExpenseDetails from './containers/expenseDetailsContainer';
import Loader from './containers/loaderContainer';
import Profile from './containers/profileContainer';
import BalanceDetails from './containers/balanceDetailsContainer';
import VendorContainer from './containers/vendorContainer';
import invoiceContainer from './containers/invoiceContainer';
import BulkVendorContainer from './containers/bulkVendorContainer';
// import DummyDetails from './components/expenses/dummy';

// import InMailDisputeLandingPage from './components/expenses/inmailDisputeLandingPage';
// import EmandateDetails from './containers/emandateDetailContainer';
const checkCookies = () => {
  const pathName = history.location.pathname;
  const query = history.location.search || '';
  const cid = cookieLib.getCookieByKey('cid');
  const token = cookieLib.getCookieByKey('token');
  // console.log(pathName.search('login') === -1, pathName.search('signup') === -1);
  if (!cid && !token && pathName.search('login') === -1) {
    if (pathName.search('signup') === -1 && pathName.search('reset') === -1) {
      if (
        [
          '/',
          '/login',
          '/dashboard',
          '/multiprofiles',
          '/alreadyLoggedIn',
        ].includes(pathName)
      ) {
        history.push('/login');
      } else if (query.search('next') === -1) {
        history.push(`/login?next=${pathName}`);
      } else {
        history.push(`/login${query}`);
      }
    }
  } else if (cid && token) {
    if (!pathName || pathName.search('login') === 1 || pathName === '/') {
      history.push('/dashboard');
    }
  }
};

const Routes = () => (
  <SnackbarProvider
    maxSnack={3}
    autoHideDuration={3000}
    disableWindowBlurListener
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
  >
    <SnackBar />
    <UserInfo />
    <Loader />
    <Switch>
      <Route path="/login" component={Login} />
      <Route exact path="/signup/:token?" component={() => <Signup />} />
      <Route exact path="/reset" component={() => <Reset />} />
      <Route exact path="/logout" component={() => <Logout />} />
      <Route
        exact
        path="/balancedetail/:balanceId"
        component={() => <BalanceDetails />}
      />
      {/* <Route
        exact
        path="/invoice/myinvoice/:id"
        component={(props) => <DummyDetails {...props}/>}
      /> */}
      {/* <Route
        exact
        path="/emandate/:emandateId"
        component={() => <EmandateDetails />}
      />  */}
      <Route
        exact
        path="/vendor/:assignType/bulkcreateview"
        component={BulkVendorContainer}
      />
      <Route
        exact
        path="/invoice/:assignType/:viewType/:invoiceId?"
        component={invoiceContainer}
      />
      <Route
        exact
        path="/vendor/:assignType/:viewType/:vendorId?"
        component={VendorContainer}
      />
      <Route exact path="/profile" component={() => <Profile />} />
      <Route path="/" component={LandingPage} />
    </Switch>
  </SnackbarProvider>
);
// const pathName = history.location.pathname;
// const avoidPath = ['/login', '/signup'];
// if (avoidPath.indexOf(pathName) === -1) {
//   checkCookies();
// }

checkCookies();
export default Routes;
